import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { map as __map, filter as __filter } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "../api-configuration";
import * as i2 from "@angular/common/http";
/**
 * Web Resource Rest Controller
 */
class WebResourceRestControllerService extends __BaseService {
    constructor(config, http) {
        super(config, http);
    }
    /**
     * @param params The `WebResourceRestControllerService.FindOneUsingGET3Params` containing the following parameters:
     *
     * - `filePath`: filePath
     *
     * - `collectionTypeName`: collectionTypeName
     *
     * - `revisionTag`: revisionTag
     *
     * @return OK
     */
    findOneUsingGET3Response(params) {
        let __params = this.newParams();
        let __headers = new HttpHeaders();
        let __body = null;
        if (params.filePath != null)
            __params = __params.set('filePath', params.filePath.toString());
        if (params.revisionTag != null)
            __params = __params.set('revisionTag', params.revisionTag.toString());
        let req = new HttpRequest('GET', this.rootUrl + `/api/webitem/collection/${params.collectionTypeName}/items/resource`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(__filter(_r => _r instanceof HttpResponse), __map((_r) => {
            return _r;
        }));
    }
    /**
     * @param params The `WebResourceRestControllerService.FindOneUsingGET3Params` containing the following parameters:
     *
     * - `filePath`: filePath
     *
     * - `collectionTypeName`: collectionTypeName
     *
     * - `revisionTag`: revisionTag
     *
     * @return OK
     */
    findOneUsingGET3(params) {
        return this.findOneUsingGET3Response(params).pipe(__map(_r => _r.body));
    }
    /**
     * @param params The `WebResourceRestControllerService.SaveUsingPOST2Params` containing the following parameters:
     *
     * - `item`: item
     *
     * - `filePath`: filePath
     *
     * - `collectionTypeName`: collectionTypeName
     *
     * - `revisionTag`: revisionTag
     *
     * @return OK
     */
    saveUsingPOST2Response(params) {
        let __params = this.newParams();
        let __headers = new HttpHeaders();
        let __body = null;
        __body = params.item;
        if (params.filePath != null)
            __params = __params.set('filePath', params.filePath.toString());
        if (params.revisionTag != null)
            __params = __params.set('revisionTag', params.revisionTag.toString());
        let req = new HttpRequest('POST', this.rootUrl + `/api/webitem/collection/${params.collectionTypeName}/items/resource`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(__filter(_r => _r instanceof HttpResponse), __map((_r) => {
            return _r;
        }));
    }
    /**
     * @param params The `WebResourceRestControllerService.SaveUsingPOST2Params` containing the following parameters:
     *
     * - `item`: item
     *
     * - `filePath`: filePath
     *
     * - `collectionTypeName`: collectionTypeName
     *
     * - `revisionTag`: revisionTag
     *
     * @return OK
     */
    saveUsingPOST2(params) {
        return this.saveUsingPOST2Response(params).pipe(__map(_r => _r.body));
    }
    /**
     * @param params The `WebResourceRestControllerService.GetResourcesUsingGET2Params` containing the following parameters:
     *
     * - `collectionTypeName`: collectionTypeName
     *
     * - `revisionTag`: revisionTag
     *
     * @return OK
     */
    getResourcesUsingGET2Response(params) {
        let __params = this.newParams();
        let __headers = new HttpHeaders();
        let __body = null;
        if (params.revisionTag != null)
            __params = __params.set('revisionTag', params.revisionTag.toString());
        let req = new HttpRequest('GET', this.rootUrl + `/api/webitem/collection/${params.collectionTypeName}/items/resource/all`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(__filter(_r => _r instanceof HttpResponse), __map((_r) => {
            return _r;
        }));
    }
    /**
     * @param params The `WebResourceRestControllerService.GetResourcesUsingGET2Params` containing the following parameters:
     *
     * - `collectionTypeName`: collectionTypeName
     *
     * - `revisionTag`: revisionTag
     *
     * @return OK
     */
    getResourcesUsingGET2(params) {
        return this.getResourcesUsingGET2Response(params).pipe(__map(_r => _r.body));
    }
    /**
     * @param params The `WebResourceRestControllerService.SavePreferencesUsingPOST2Params` containing the following parameters:
     *
     * - `item`: item
     *
     * - `filePath`: filePath
     *
     * - `collectionTypeName`: collectionTypeName
     *
     * - `revisionTag`: revisionTag
     *
     * @return OK
     */
    savePreferencesUsingPOST2Response(params) {
        let __params = this.newParams();
        let __headers = new HttpHeaders();
        let __body = null;
        __body = params.item;
        if (params.filePath != null)
            __params = __params.set('filePath', params.filePath.toString());
        if (params.revisionTag != null)
            __params = __params.set('revisionTag', params.revisionTag.toString());
        let req = new HttpRequest('POST', this.rootUrl + `/api/webitem/collection/${params.collectionTypeName}/items/resource/preferences`, __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(__filter(_r => _r instanceof HttpResponse), __map((_r) => {
            return _r;
        }));
    }
    /**
     * @param params The `WebResourceRestControllerService.SavePreferencesUsingPOST2Params` containing the following parameters:
     *
     * - `item`: item
     *
     * - `filePath`: filePath
     *
     * - `collectionTypeName`: collectionTypeName
     *
     * - `revisionTag`: revisionTag
     *
     * @return OK
     */
    savePreferencesUsingPOST2(params) {
        return this.savePreferencesUsingPOST2Response(params).pipe(__map(_r => _r.body));
    }
}
WebResourceRestControllerService.ngInjectableDef = i0.defineInjectable({ factory: function WebResourceRestControllerService_Factory() { return new WebResourceRestControllerService(i0.inject(i1.ApiConfiguration), i0.inject(i2.HttpClient)); }, token: WebResourceRestControllerService, providedIn: "root" });
export { WebResourceRestControllerService };
